import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@gray/domain/http/api.service';

@Injectable({providedIn: 'root'})
export class CoachQuickNoteService {

  private apiPrefix = '/coach/quick-notes';

  constructor(
    private api: ApiService,
  ) {
  }

  getNotes(queryString = ''): Observable<any> {
    return this.api.get(`${this.apiPrefix}`, queryString);
  }

  createNote(content: string): Observable<any> {
    return this.api.post(`${this.apiPrefix}`, {content});
  }

  deleteNote(noteId: number): Observable<any> {
    return this.api.delete(`${this.apiPrefix}/${noteId}`);
  }
}
